/* eslint-disable no-console */
import { getUserData } from './wam';
import { getIdsFromHash } from './url';

export const migrateToFieldViewNewArch = (newArchFeatureFlag) => {
  const currentPath = window.location.pathname;
  const currentUrl = window.location.href;

  const { fieldId, mapLayerIds, seasonIds } = getIdsFromHash();

  const { clientId } = getUserData();
  const isGlobalExp = currentPath.includes('/global/exp');

  const redirectdmbUrlPlugin = `/static/field-view/#/dmb/${fieldId}/${seasonIds}/${mapLayerIds}?client-id=${clientId}`
  const redirectdmbUrlSpa = `/static/dmb/?client-id=${clientId}#/${fieldId}/${seasonIds}/${mapLayerIds}`

  const dmbUrlSpa = '/static/dmb/';
  const dmbExpSpa = '/static/global/exp/dmb/';
  const dmbExpPlugin = '/static/global/exp/field-view/#/dmb/';

  const isExpSPA = currentPath.includes(dmbExpSpa);
  const isExpPlugin = currentPath.includes(dmbExpPlugin);

  // This case will consider if it is exp link
  if (!isGlobalExp) {
    // This case means that the application is DMB as SPA and new Arch flag is true
    if(currentPath.includes(dmbUrlSpa) && newArchFeatureFlag){
      window.location.replace(redirectdmbUrlPlugin);

      // This case means that the application is DMB as Plugin and new Arch flag is false
    } else if (currentPath.includes('/static/field-view') && newArchFeatureFlag === false) {
      window.location.replace(redirectdmbUrlSpa);
    }
    // This case means that the application is on exp link and is being test as SPA and the new Arch flag is true
  } else if (isExpSPA && newArchFeatureFlag) {
    const pathNameWithQueryParamsAndHash = currentUrl.replace(window.location.origin, '');
    const newUrl = currentUrl.replace(pathNameWithQueryParamsAndHash, redirectdmbUrlPlugin)

    window.location.replace(newUrl);
    // This case means that the application is on exp link and is being test as Plugin and the new Arch flag is false
  } else if (isExpPlugin && !newArchFeatureFlag) {
    window.location.replace(currentUrl.replace(dmbExpPlugin, dmbUrlSpa))
  };
};
